//@ts-ignore
import { motion } from 'framer-motion';

import Logo from '../logo/Logo';

const SIDEBAR_STORAGE_KEY = 'sidebar_state';
const SIDEBAR_WIDTH = '267px';
const SIDEBAR_WIDTH_ICON = '72px';

/**
 * TODO: Move to `ui-next` so that constants can be shared.
 */
export default function LoadingScreen() {
  const sidebarState = localStorage.getItem(SIDEBAR_STORAGE_KEY);
  const sidebarOpen = sidebarState === 'true' ? true : false;

  return (
    <div className="h-full w-full">
      <div className="fixed left-0 top-0 flex flex-row">
        <div
          className="dark bg-background left-0 top-0 h-screen"
          style={{ width: sidebarOpen ? SIDEBAR_WIDTH : SIDEBAR_WIDTH_ICON }}
        />
        <div className="dark bg-background relative h-[96px] w-screen">
          <Notch />
        </div>
      </div>
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-inherit">
        <motion.div
          initial={{ rotateY: 0 }}
          animate={{ rotateY: 360 }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          <Logo sx={{ height: 64 }} />
        </motion.div>

        <motion.div
          animate={{
            scale: [1.2, 1, 1, 1.2, 1.2],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          className="absolute w-[100px] h-[100px] border-[3px] border-primary rounded-[25%]"
        />
      </div>
    </div>
  );
}

const Notch = () => {
  return (
    <svg
      className="absolute left-0 bottom-0 translate-y-full fill-background"
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.9258 0C22.7113 9.59032e-05 21.5654 0.563102 20.8232 1.52441L0.817383 27.4414C0.287733 28.1275 1.50667e-05 28.9701 0 29.8369V0H23.9258Z" />
    </svg>
  );
};
